/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { PostV1UsersAddressesMutationRequest, PostV1UsersAddressesMutationResponse, PostV1UsersAddresses422 } from "../../../types/PostV1UsersAddresses.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getPostV1UsersAddressesUrlClient() {
  const res = { method: 'POST', url: `/v1/users/addresses` as const }
  return res
}

/**
 * @summary Create address
 * {@link /v1/users/addresses}
 */
export async function postV1UsersAddressesClient(data: PostV1UsersAddressesMutationRequest, config: Partial<RequestConfig<PostV1UsersAddressesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostV1UsersAddressesMutationResponse, ResponseErrorConfig<PostV1UsersAddresses422>, PostV1UsersAddressesMutationRequest>({ method : "POST", url : getPostV1UsersAddressesUrlClient().url.toString(), data : requestData, ... requestConfig })
  return res
}